import React from 'react';
import styled from "styled-components";
import theme from "./../../../Theme/Theme"
import {Div, Icon} from "atomize";
import { HashLink } from 'react-router-hash-link';

const Link = styled(HashLink)`
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  color: ${theme.colors.primary};
  letter-spacing: 0;
  text-align: center;
  line-height: 20px;
  
  transition: color .25s ease-in-out;
  
  &:hover, &:focus {
    color: ${theme.colors.secondary};
  }
`;

const Wrapper = styled(Div)`
  display: flex;
`;

const AnchorLink = (props) => {

  return (
    <Wrapper>
      <Icon name="Link" size="20px" style={{ marginRight: '.25rem'}} color={theme.colors.primary} />
      <Link
        to={ props.path + '#' + props.id }
      >{props.title}</Link>
    </Wrapper>
  )
};

export default AnchorLink

